import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowUpRight, FiArrowRight, FiCheck, FiMapPin, FiStar, FiBarChart2 } = FiIcons;

function MomentumPanel() {
  const items = [
    { icon: FiMapPin, label: 'Google Business Profile', detail: 'Posts,photos & updates', color: 'bg-[#3fc0fa]' },
    { icon: FiStar, label: 'Reviews & reputation', detail: 'Requests,replies & follow-ups', color: 'bg-[#f8b86a]' },
    { icon: FiBarChart2, label: 'Rankings & reporting', detail: 'Heatmaps & progress updates', color: 'bg-[#a7e2be]' }
  ];

  return (
    <div className="relative mx-auto max-w-[530px]">
      <div className="absolute -inset-3 rounded-[2rem] border border-[#3fc0fa]/20 sm:-inset-5" />
      <div className="relative rounded-[1.7rem] border border-white/10 bg-[#18263b] p-5 shadow-2xl sm:p-7">
        <div className="flex items-center justify-between border-b border-white/10 pb-5">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#3fc0fa]">Local Momentum</p>
            <h2 className="mt-1 text-xl font-bold text-white">Your local presence,handled.</h2>
          </div>
          <span className="h-3 w-3 rounded-full bg-[#3fc0fa]" />
        </div>
        <div className="mt-5 space-y-3">
          {items.map((item) => (
            <div key={item.label} className="flex items-center gap-4 rounded-2xl bg-[#22344d] p-4">
              <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl text-[#0b1423] ${item.color}`}>
                <SafeIcon icon={item.icon} className="h-5 w-5" />
              </span>
              <div>
                <p className="font-bold text-white">{item.label}</p>
                <p className="mt-0.5 text-sm text-slate-300">{item.detail}</p>
              </div>
              <SafeIcon icon={FiCheck} className="ml-auto shrink-0 text-[#3fc0fa]" />
            </div>
          ))}
        </div>
        <div className="mt-5 flex items-center justify-between rounded-2xl bg-[#3fc0fa] px-5 py-4 text-[#0b1423]">
          <span className="text-sm font-bold">One simple plan</span>
          <span className="text-xl font-black">$399<span className="text-sm font-semibold">/month</span></span>
        </div>
      </div>
    </div>
  );
}

export default function HeroSection() {
  return (
    <section className="overflow-hidden bg-[#0b1423] pb-24 pt-32 text-white sm:pb-32 sm:pt-40">
      <div className="mx-auto grid max-w-7xl items-center gap-16 px-4 sm:px-6 lg:grid-cols-[1.08fr_0.92fr] lg:gap-12 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.65 }}>
          <div className="mb-7 inline-flex items-center gap-2 rounded-full border border-[#3fc0fa]/30 px-4 py-2 text-xs font-bold uppercase tracking-widest text-[#3fc0fa]">
            <span className="h-2 w-2 rounded-full bg-[#3fc0fa]" /> Local marketing,done for you
          </div>
          <h1 className="max-w-3xl text-5xl font-black leading-[1.04] tracking-[-0.055em] sm:text-6xl xl:text-[5.4rem]">
            Show up locally. <span className="text-[#3fc0fa]">Stay top of mind.</span>
          </h1>
          <p className="mt-7 max-w-xl text-lg leading-relaxed text-slate-300 sm:text-xl">
            We manage your Google Business Profile,reviews,local content and reporting every month. You run your business;we keep your presence moving.
          </p>
          <div className="mt-9 flex flex-col gap-3 sm:flex-row">
            <Link to="/pricing" className="site-button inline-flex items-center justify-center gap-3 rounded-full px-7 py-4 font-bold">
              Explore Local Momentum <SafeIcon icon={FiArrowUpRight} />
            </Link>
            <Link to="/results" className="site-outline inline-flex items-center justify-center gap-3 rounded-full px-7 py-4 font-bold">
              See the results <SafeIcon icon={FiArrowRight} />
            </Link>
          </div>
          <div className="mt-9 flex flex-wrap gap-x-6 gap-y-2 text-sm text-slate-400">
            <span className="flex items-center gap-2"><SafeIcon icon={FiCheck} className="text-[#3fc0fa]" /> No SEO experience needed</span>
            <span className="flex items-center gap-2"><SafeIcon icon={FiCheck} className="text-[#3fc0fa]" /> Optional post approval</span>
          </div>
        </motion.div>
        <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.15 }}>
          <MomentumPanel />
        </motion.div>
      </div>
    </section>
  );
}